import React from 'react'
import { Redirect, Route } from 'react-router-dom'

// The SSO staff pages used to live under /admin/provider/... and now live
// under /admin/sso/... (the UI calls them SSO connections). Emails already
// sent link to /admin/provider/list/edit/<id>, and bookmarks exist, so every
// old URL redirects (replace, never a history entry) to its new place with the
// query string and hash kept.
//
//   list                  -> connections
//   list/edit/:id[/...]   -> connections/:id[/...]
//   list/add, list/recycle -> connections/add, connections/recycle
//   anything else         -> the same name under /admin/sso (connect, domains,
//                            consent-requests, health, findings, notifications, jobs)
export const ssoPathOf = pathname =>
  pathname
    .replace(/^\/admin\/provider\/list\/edit(\/|$)/, '/admin/sso/connections$1')
    .replace(/^\/admin\/provider\/list(\/|$)/, '/admin/sso/connections$1')
    .replace(/^\/admin\/provider(\/|$)/, '/admin/sso$1')

export const ProviderLegacyRedirect = () =>
  <Route
    path="/admin/provider"
    render={({ location }) =>
      <Redirect to={{ pathname: ssoPathOf(location.pathname), search: location.search, hash: location.hash }} />}
  />
